import { render, staticRenderFns } from "./CreateDiagPage.vue?vue&type=template&id=a301e716"
import script from "./CreateDiagPage.js?vue&type=script&lang=js&external"
export * from "./CreateDiagPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports